import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LIST, SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_UPDATE, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE } from "../../../routes";
import { ShuttleBusBookingConfigureSuspensionHeader } from "./add_header";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import NextIcon from "../../../assets/communication/NextIcon.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";

import { ShuttleBusBookingConfigureSuspensionSteps } from "./add_steps";
import { TextBox } from "@progress/kendo-react-inputs";
import { createAndUpdateConfigureSuspension, fetchConfigureSuspensionDetail } from "../../../store/shuttle_bus_booking/configure_suspension";
import { DropDownList } from "@progress/kendo-react-dropdowns";

export const ShuttleBusBookingConfigureSuspensionUpdate = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);

  const [errors, setErrors] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSubmitConfirmDialog, setShowSubmitConfirmDialog] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const [selected_tab, setSelectedTab] = useState(
    parseInt(query.get("state", 0)) || 0
  );
  const [id, setId] = useState(
    query.get("id", "")
  );

  const userPermissions = getUserPermission();

  const updatePermssion = checkPermission(
    userPermissions,
    "bus_booking.update_suspension_config"
  );

  const [editData, setEditData] = useState({
    sk: '',
    is_enabled: true,
    threshold: 0,
    config_id: '',
    value: 0,
    period_range: 'weeks',
    pk: 'suspension',
  });



  const { detail_data, detail_loading } = useSelector(
    (state) => state.shuttleBusConfigureSuspension
  );

  const getData = async () => {
    dispatch(fetchConfigureSuspensionDetail(id));
  };


  useEffect(() => {
    getData();
  }, [id]);

  useEffect(() => {
    if (!detail_data || initialized) return;

    setEditData({
      sk: detail_data.sk,
      is_enabled: detail_data.is_enabled,
      threshold: detail_data.threshold,
      config_id: detail_data.config_id,
      value: detail_data.value,
      period_range: detail_data.period_range == 'weeks' ? 'Weeks' : 'Months',
      pk: detail_data.pk,
    });

    setInitialized(true);

  }, [detail_data, initialized]);



  const handleSubmit = () => {
    setLoading(true);
    editData.period_range = editData.period_range == 'Weeks' ? 'weeks' : 'months';

    dispatch(createAndUpdateConfigureSuspension({ data: editData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {

        setLoading(false);
        navigate(SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LIST);

      } else {
        setLoading(false);


      }
    });


  };


  const checkMandatoryFields = () => {

    const { threshold, value } = editData;

    if (!threshold || !value) {
      console.error("All fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }

    setShowRequiredFieldError(false);

    return false;
  }


  const handleNext = () => {

    if (checkMandatoryFields()) return;


    let tab = parseInt(selected_tab) + 1;

    setSelectedTab(tab);
    setId(id);
    query.set("state", tab);
    navigate(SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_UPDATE + "?" + query.toString());
  };

  const callback_handleBackBtn = (e) => {

    if (parseInt(selected_tab) === 0) {
      navigate(SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LIST);
      return;
    }

    let currentTab = selected_tab > 0 ? (selected_tab - 1) : 0;

    if (id) {
      query.set("id", id);
    }
    query.set("state", currentTab);

    setSelectedTab(currentTab);
    navigate(SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_UPDATE + "?" + query.toString());
  };

  const getSortIcon = () => {
    return (<svg width="10" height="14" viewBox="0 0 10 14">
      <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
      <path d="M0 8 L5 13 L10 8 Z" fill="#999" />
    </svg>);
  };



  return (
    <>
      {(id && updatePermssion) ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showSubmitConfirmDialog && (
            <Dialog
              className="alert-form"
              title={"Confirmation"}
              width={500}
              // height={280}
              onClose={() => setShowSubmitConfirmDialog(false)}
            >
              <p className="campaigns-dialog-text-align"><b>Are you sure you want to submit this Configure Rules for Suspension Matrix?</b></p>
              <p className="shuttle_bus_booking_dialog-text-align">Once submitted, you will not be able to upload files again unless the approver rejects it or the admin recreates the campaign.</p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setShowSubmitConfirmDialog(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowSubmitConfirmDialog(false);
                    handleSubmit();
                  }}
                >
                  Submit
                </div>
              </div>
            </Dialog>
          )}


          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}



          {(detail_loading || loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <ShuttleBusBookingConfigureSuspensionHeader
            backBtncallback={(e) => callback_handleBackBtn(e)}
            state={selected_tab}
          />
          <ShuttleBusBookingConfigureSuspensionSteps
            state={selected_tab}
            setState={setSelectedTab}
            checkMandatoryFields={checkMandatoryFields}
            handleSubmit={handleSubmit}
            editData={editData}
          />

          <div className="main-shuttle-bus-container-with-header">
            <div className="main-poll-survey">
              {selected_tab == 0 && (
                <div className="shuttle_bus_booking_create_item_main_box_detail">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Configure Rules for Suspension Matrix
                  </div>
                  <div style={{ marginTop: "10px", border: "1px solid #eee", borderRadius: "5px" }}>

                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th>
                            Type {getSortIcon()}
                          </th>
                          <th>
                            Number of Absence/Cancelled {getSortIcon()}
                          </th>
                          <th>
                            Limit {getSortIcon()}
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr key={'configure-suspension'} style={{ height: "100px" }}>
                          <td>
                            {editData.sk}
                          </td>
                          <td>
                            <TextBox
                              className="shuttle_bus_booking_create_item_main_box_field"
                              value={editData.threshold}
                              type="number"
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  threshold: e.target.value,
                                })
                              }
                            />
                          </td>
                          <td>
                            <div style={{ display: 'flex', gap: '10px' }}>

                              <TextBox
                                className="shuttle_bus_booking_create_item_main_box_field"
                                style={{width: '200px'}}
                                value={editData.value}
                                type="number"
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    value: e.target.value,
                                  })
                                }
                              />
                              <div className="shuttle_bus_add_dropdown" style={{width: '200px'}}>
                                <DropDownList
                                  style={{ height: "48px" }}
                                  data={['Weeks', 'Months']}
                                  onChange={(e) => {                                    
                                    setEditData({
                                      ...editData,
                                      period_range: e.value,
                                    })
                                  }}
                                  value={editData.period_range}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>



                </div>
              )}

              {selected_tab == 1 && (
                <div className="shuttle_bus_booking_create_item_main_box_detail">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Max geofence area  & available seat
                  </div>
                  <div style={{ marginTop: "10px", border: "1px solid #eee", borderRadius: "5px" }}>

                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th>
                            Type {getSortIcon()}
                          </th>
                          <th>
                            Number of Absence/Cancelled {getSortIcon()}
                          </th>
                          <th>
                            Limit {getSortIcon()}
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr key={'configure-suspension-review'} style={{ height: "100px" }}>
                          <td>{editData.sk}</td>
                          <td>{editData.threshold}</td>
                          <td>{`${editData.value} ${editData.period_range}`}</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>



                </div>
              )}
            </div>

            <div className="campaigns-survey-footer">
              <div className="footer-left-btn-groups">
                {selected_tab !== 0 &&
                  <Button
                    className="footer-previous-btn font-family-poppins"
                    onClick={() => {
                      callback_handleBackBtn();
                    }}
                  >
                    Previous
                  </Button>
                }
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST);
                  }}
                >
                  Cancel
                </Button>
              </div>

              {selected_tab !== 1 &&
                <div className="footer-right">

                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      handleNext();
                    }}
                  >
                    Next
                    <Icon>
                      <img alt="" src={NextIcon} />
                    </Icon>
                  </Button>
                </div>
              }

              {selected_tab === 1 &&
                <div className="footer-right">
                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      setShowSubmitConfirmDialog(true);

                    }}
                  >
                    Submit
                  </Button>
                </div>
              }

            </div>
          </div>



        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
